import { render, staticRenderFns } from "./Confidential.vue?vue&type=template&id=f829e50c&scoped=true&"
import script from "./Confidential.vue?vue&type=script&lang=ts&"
export * from "./Confidential.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f829e50c",
  null
  
)

export default component.exports